import React from "react";
import "./DownloadFormPage.css";
import BannerImg from "../Component/Download-Form.jpg";

// Import Actual PDF Files
import SakshamForm from "../Component/Candidate Enrolment form (Saksham).pdf";
import CPITForm from "../Component/CPIT Form.pdf";

const DownloadFormPage = () => {
  const courses = [
    { name: "Candidate Enrolment Form (Saksham)", file: SakshamForm },
    { name: "CPIT Form", file: CPITForm },
  ];

  return (
    <div className="course-page">
      {/* ===== Banner Section ===== */}
      <div className="course-banner">
        <img src={BannerImg} alt="Download Forms" className="banner-img" />
      </div>

      {/* ===== Content Section ===== */}
      <div className="course-content">
        <h2>Download Registration Forms</h2>

        <p className="course-text" style={{ textAlign: "center" }}>
          You can download the registration forms below. Please fill them carefully
          and submit them as per the given instructions.
        </p>

        <div className="form-list">
          {courses.map((course, index) => (
            <div key={index} className="form-card">
              <h4>{course.name}</h4>

              {/* Download Button */}
              <a href={course.file} download>
                <button className="download-btn">Download PDF</button>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DownloadFormPage;
